import { TSalesRegion } from './TProject';

export interface TUser {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  countries: string[];
  projects: string[];
  projectsRegions: ProjectRegions[];
  categories: string[];
  level: UserLevel;
  userAccessLevel: UserAccessLevel;
  status: UserStatus;
}

export enum UserStatus {
  Active,
  Inactive
}

export enum UserLevel {
  Admin,
  User
}

export enum UserAccessLevel {
  KAM,
  Sales,
  Marketing
}

export interface ProjectRegions {
  projectId: string;
  regions: TSalesRegion[];
}
